import {GraphQLClient} from "graphql-request";

export async function deleteAsset(id: string) {
    const url = process.env.REACT_APP_GRAPHCMS_ENDPOINT!!
    const graphcms = new GraphQLClient(url, {
        headers: { "Authorization" : `Bearer ${process.env.REACT_APP_GRAPHCMS_AUTH_TOKEN}`}
    })
    const res = await graphcms.request(
        `
        mutation($id: ID!) {
          deleteAsset(where: { id: $id }){
            id
          }
        }
        `,
        { id: id }
    )

    return {res};
}

export async function createAsset(file: any): Promise<any> {
    const url = process.env.REACT_APP_GRAPHCMS_ENDPOINT!!;
    const graphcms = new GraphQLClient(url, {
        headers: { "Authorization" : `Bearer ${process.env.REACT_APP_GRAPHCMS_AUTH_TOKEN}`}
    });

    let {createAsset} = await graphcms.request(
        `mutation createAsset {
            createAsset(data: {}) {
                id
                url
                upload {
                    status
                    expiresAt
                    error {
                        code
                        message
                    }
                    requestPostData {
                        url
                        date
                        key
                        signature
                        algorithm
                        policy
                        credential
                        securityToken
                    }
                }
            }
        }`,
        {}
    )

    let formData = new FormData();
    formData.set('X-Amz-Date', createAsset.upload.requestPostData.date);
    formData.set('key', createAsset.upload.requestPostData.key);
    formData.set('X-Amz-Signature', createAsset.upload.requestPostData.signature);
    formData.set('X-Amz-Algorithm', createAsset.upload.requestPostData.algorithm);
    formData.set('policy', createAsset.upload.requestPostData.policy);
    formData.set('X-Amz-Credential', createAsset.upload.requestPostData.credential);
    formData.set('X-Amz-Security-Token', createAsset.upload.requestPostData.securityToken);
    formData.set('file', file.file);

    const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    await fetch(createAsset.upload.requestPostData.url, {
        method: 'POST',
        body: formData
    })
    .then(async data => {
        await sleep(2000);
        await graphcms.request(
            `mutation publishAsset($id: ID!) {
                publishAsset(where: {id: $id}) {
                    id
                }
            }`,
            { id: createAsset.id }
        )
    })

    return createAsset.id;
}